export function arrowThumbnailsDisabler(Glide, Components) {
  return {
    mount() {
      if (Glide.settings.rewind) {
        return;
      }

      Glide.on(['mount.after', 'run'], () => {
        // Filter out arrows_control
        const itemsLength = Components.Sizes.length - 1; /* Remove border slide */
        const perViewSettings = +Number(Glide.settings.perView).toFixed(0);

        for (let i = 0; i < Components.Controls.items.length; i++) {
          const controlItem = Components.Controls.items[i];
          // if (controlItem.className !== 'glide__arrows') {
          //   continue;
          // }

          // Set left arrow state
          const left = controlItem.querySelector('.glide__arrow--left');

          if (left) {
            if (Glide.index === 0) {
              left.setAttribute('disabled', '');
            } else {
              left.removeAttribute('disabled', '');
            }
          }

          // Set right arrow state
          const right = controlItem.querySelector('.glide__arrow--right');

          if (right) {
            if (Glide.index === itemsLength - perViewSettings || itemsLength <= perViewSettings) {
              right.setAttribute('disabled', '');
            } else {
              right.removeAttribute('disabled', '');
            }
          }
        }
      });
    },
  };
}
